import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=7b17d9dc&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=ts"
export * from "./Spaces.vue?vue&type=script&lang=ts"
import style0 from "./Spaces.vue?vue&type=style&index=0&id=7b17d9dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17d9dc",
  null
  
)

export default component.exports